export default __webpack_public_path__ + "static/media/projectBg.2d0ae381.png";